<template>
  <Drawer width="700" v-model="drawerOpened" :title="openedData ? '编辑联系人' : '创建联系人' ">
    <div class="drawer-content">
      <Form
        ref="formItem"
        :rules="ruleValidate"
        :model="formItem"
      >
        <div class="formItem" :style="formItemStyle">
          <div class="formItem-left">
            <FormItem
              label="姓名"
              prop="name"
            >
              <Input
                style="width: 300px"
                v-model="formItem.name"
                placeholder="输入姓名"
              />
            </FormItem>
            <FormItem label="客户" prop="customer" style="width: 250px">
              <Select
                v-model="formItem.customer"
                filterable
                remote
                multiple
                style="width: 300px"
                :remote-method="remoteMethod"
                placeholder="请选择客户"
              >
                <Option
                  v-for="option in customerList"
                  :value="option._id"
                  :key="option._id"
                  style="width: 300px"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="部门" prop="department" style="width: 250px">
              <Input
                style="width: 300px"
                v-model="formItem.department"
                placeholder="输入部门"
              />
            </FormItem>
            <FormItem
              label="手机"
              prop="mobile"
            >
              <Input
                style="width: 300px"
                type="tel"
                v-model="formItem.mobile"
                placeholder="输入手机"
              />
            </FormItem>
            <FormItem
              label="头衔"
              prop="title"
            >
              <Input
                style="width: 300px"
                v-model="formItem.title"
                placeholder="输入头衔"
              />
            </FormItem>
            <FormItem
              label="之前工作"
              prop="historyWorkInCustomer"
            >
              <Input
                style="width: 300px"
                v-model="formItem.historyWorkInCustomer"
                placeholder="输入之前工作"
              />
            </FormItem>
            <FormItem
              label="备注"
              prop="remark"
            >
              <Input
                type="textarea"
                v-model="formItem.remark"
                placeholder="输入备注"
              />
            </FormItem>
          </div>
          <div class="formItem-right">
            <FormItem
              label="支付方式"
              prop="paymentMethod"
            >
              <Select v-model="formItem.paymentMethod">
                  <Option v-for="item in paymentMethodList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="微信账号" prop="wechatAccount">
              <Input
                style="width: 300px"
                v-model="formItem.wechatAccount"
                placeholder="输入微信账号"
              />
            </FormItem>
            <FormItem
              label="银行回款名"
              prop="bankRecieverName"
            >
              <Input
                style="width: 300px"
                type="tel"
                v-model="formItem.bankRecieverName"
                placeholder="输入银行回款名"
              />
            </FormItem>
            <FormItem
              label="银行账号"
              prop="bankAccount"
            >
              <Input
                style="width: 300px"
                v-model="formItem.bankAccount"
                placeholder="输入银行账号"
              />
            </FormItem>
            <FormItem
              label="银行"
              prop="bank"
            >
              <Input
                v-model="formItem.bank"
                placeholder="输入银行"
              />
            </FormItem>
            <FormItem
              label="支付宝账号"
              prop="alipayAccount"
            >
              <Input
                v-model="formItem.alipayAccount"
                placeholder="输入支付宝账号"
              />
            </FormItem>
          </div>
        </div>
        <div class="bottom-button">
          <FormItem style="margin-left: 16px;margin-bottom: 0">
            <Button
              type="primary"
              @click="handleSubmit('formItem')"
            >保存</Button>
          </FormItem>
          <FormItem style="margin-right: 16px;margin-bottom: 0" v-if="openedData">
            <Button
              type="error"
              ghost
              @click="delCustomerCantact()"
            >删除</Button>
          </FormItem>
        </div>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import lodash from "lodash";

export default {
  name: "EditCustomerContactDrawer",
  data() {
    return {
      drawerOpened: false,
      openedData: undefined,
      formItem: {
        name: null,
        customer: null,
        mobile: null,
        title: null,
        historyWorkInCustomer: null,
        remark: null,
        paymentMethod: null,
        wechatAccount: null,
        bankRecieverName: null,
        bankAccount: null,
        bank: null,
        alipayAccount: null,
        department: null,
      },
      customerLoading: false,
      paymentMethodList: [
        {
          value: "wechat",
          label: "微信"
        },
        {
          value: "bankTransfer",
          label: "银行转账"
        },
        {
          value: "alipay",
          label: "支付宝"
        },
        {
          value: "cash",
          label: "现金"
        },
      ],
      ruleValidate: {
        name: [
          { required: true, message: "姓名为必填项", trigger: "blur" }
        ],
        customer: [
          { required: true, message: "客户为必选项", trigger: "blur", type: "array" }
        ],
      },
      formItemStyle: {
        overflowY: "hidden",
        overflowX: "hidden",
        height: 700,
      },
      customerList: [],
    };
  },
  computed: {
    ...mapState({
      customersSimple: (state) => state.customer.customersSimple,
    }),
  },
  methods: {
    ...mapActions({
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
      createCustomerContact: "customerContact/createCustomerContactAction",
      updateCustomerContact: "customerContact/updateCustomerContactAction",
      deleteCustomerContact: "customerContact/deleteCustomerContactAction",
    }),

    async openDrawer(openedData) {
      this.drawerOpened = true;
      this.openedData = openedData;
      Object.keys(this.formItem).forEach((key) => (this.formItem[key] = null));
      if (openedData) {
        for (let key in openedData) {
        if (key === 'customer') {
          this.customerList = openedData[key]
          this.formItem[key] = openedData[key].map(x => x._id)
        }else if (key === 'historyWorkInCustomer') {
          this.formItem[key] = openedData[key].join(",");
        }else if (key === 'paymentMethod') {
          this.formItem[key] = openedData[key];
        }else if (key in this.formItem) {
          this.formItem[key] = openedData[key];
        }
      }
      } else {
        
      }
    },

    async remoteMethod(query) {
      if (query !== "") {
        this.customerLoading = true;
        const data = await this.getCustomerSimpleList({ name: query });
        this.customerList = data.customerList
        this.customerLoading = false;
      }
    },

    async handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            let form = this.formItem
            // 去除为null的内容
            Object.keys(form).forEach((key) => {
              if (form[key] === null) {
                delete form[key];
              }
            });
            if (this.openedData) {
              let formItem = lodash.cloneDeep(this.formItem);
              for (const key in formItem) {
                if (
                  Object.prototype.toString.call(this.openedData[key]) ===
                  "[object Object]"
                ) {
                  if (formItem[key] === this.openedData[key]._id) {
                    delete formItem[key];
                  }
                } else {
                  if (formItem[key] === this.openedData[key]) {
                    delete formItem[key];
                  }
                }
              }
              formItem.historyWorkInCustomer = []
              await this.updateCustomerContact({
                id: this.openedData._id,
                data: formItem,
              });
              this.$Message.success("编辑成功!");
              this.drawerOpened = false;
            } else {
              await this.createCustomerContact({form})
              this.$Message.success("创建成功!");
              this.drawerOpened = false;
            }
          } catch (error) {
            this.$Message.error(`编辑失败!${error}`);
          }
        } else {
          this.$Message.error("验证未通过!");
        }
      })
    },
    async delCustomerCantact() {
      try {
        await this.deleteCustomerContact(this.openedData._id)
        this.$Message.success("删除成功!");
        this.drawerOpened = false;
      } catch (error) {
        this.$Message.error(`删除失败失败!${error}`);
      }
    },
    getHeight() {
      this.formItemStyle.height = window.innerHeight - 130 + "px";
    },
  },
  created() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },

  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
};
</script>

<style  scoped lang="stylus">
.formItem
  display flex
  justify-content space-between

.formItem-left
  margin-right 20px
  padding 0 0 50px 16px
  width 350px
  overflow-x hidden

.formItem-right
  margin-bottom 100px
  overflow-x hidden

.drawer-content
  overflow-y hidden
  padding-left 0

.bottom-button
  position fixed
  bottom 0px
  width 700px
  height 64px
  background-color #f2f6fa
  display flex
  align-items center
  z-index 1
  display: flex
  justify-content: space-between
</style>